'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextEditor = exports.SimpleTextEditor = undefined;

var _SimpleTextEditor2 = require('./simpleText/SimpleTextEditor');

var _SimpleTextEditor3 = _interopRequireDefault(_SimpleTextEditor2);

var _RichTextEditor2 = require('./richText/RichTextEditor');

var _RichTextEditor3 = _interopRequireDefault(_RichTextEditor2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SimpleTextEditor = _SimpleTextEditor3.default;
exports.RichTextEditor = _RichTextEditor3.default;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/index.js
// module id = 681
// module chunks = 0